import campaignService from "./campaignService";
const { REACT_APP_API_HOST } = process.env;

function apiURL(path) {
  return [
    REACT_APP_API_HOST,
    campaignService.getLanguageCode(),
    campaignService.getCampaignName(),
    path,
  ].join("/");
}

export default {
  apiURL,
};
